export const SiteOptions = {
    REPORTS: 'REPORTS',
    DASHBOARDS: 'DASHBOARDS',
} as const;

export type SITE = (typeof SiteOptions)[keyof typeof SiteOptions];
